import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import FeedbackIcon from '@atlaskit/icon/core/feedback';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Pressable from '@atlaskit/primitives/pressable';
import Inline from '@atlaskit/primitives/inline';
import { xcss } from '@atlaskit/primitives/xcss';

import { FeedbackType } from '@atlassian/company-hub-common/types';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

import { useFeedbackCollector } from './useFeedbackCollector.tsx';

const i18n = defineMessages({
	shareFeedbackButtonLabel: {
		id: 'company-hub-utils.share-feedback-button.label',
		defaultMessage: 'Share feedback on Company hub',
		description: 'CTA button text for users to provide feedback on their Company hub experience',
	},
});

const layoutStyles = xcss({
	position: 'fixed',
	margin: 'space.050',
	bottom: 'space.150',
});

const leftPosition = xcss({
	left: 'calc(space.150 + var(--leftSidebarWidth, 0px))',
});

const buttonStyles = xcss({
	borderRadius: 'radius.small',
	backgroundColor: 'elevation.surface',
	boxShadow: 'elevation.shadow.overlay',
	color: 'color.text',
	paddingBlock: 'space.050',
	paddingInline: 'space.100',
	display: 'flex',
	columnGap: 'space.050',
	alignItems: 'center',
	':hover': {
		cursor: 'pointer',
		backgroundColor: 'elevation.surface.overlay.hovered',
	},
	':active': {
		backgroundColor: 'elevation.surface.overlay.pressed',
	},
});

export const ShareFeedbackButtonInner = (): React.JSX.Element => {
	const openFeedbackCollector = useFeedbackCollector({
		source: 'companyHubViewPage',
		type: FeedbackType.COMPANY_HUB,
	});

	return (
		<Inline testId="layoutContainer" xcss={[layoutStyles, leftPosition]}>
			<Pressable xcss={buttonStyles} onClick={openFeedbackCollector}>
				<FeedbackIcon label="" spacing="spacious" />
				<FormattedMessage {...i18n.shareFeedbackButtonLabel} />
			</Pressable>
		</Inline>
	);
};

const ShareFeedbackButtonComponent = () => {
	return <ShareFeedbackButtonInner />;
};

export const ShareFeedbackButton: React.FC<{}> = withTransparentErrorBoundary({
	attribution: Attribution.MIGRATIONS_TOOLING,
})(ShareFeedbackButtonComponent);
